/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import { ACCOUNT_LABEL } from '../constants/entityLabels';

/**
 * "The Agentic AI platform did not respond properly" errors, tagged by the
 * server with a `code` (see AgenticAiService.toHttpError / requireHost).
 */
export const AGENTIC_AI_SERVICE_ERRORS = {
  AI_AGENT_UNAVAILABLE: {
    kind: 'unavailable',
    title: 'AI Agent service is not responding',
    message: 'We could not reach the AI Agent service right now. This is usually temporary — please try again in a moment.',
    toast: 'The AI Agent service is not responding right now. Please try again in a moment.',
  },
  AI_AGENT_TIMEOUT: {
    kind: 'timeout',
    title: 'AI Agent service is taking too long',
    message: 'The AI Agent service did not answer in time. It may be busy — please try again in a moment.',
    toast: 'The AI Agent service took too long to respond. Please try again.',
  },
  AI_AGENT_NOT_CONFIGURED: {
    kind: 'not_configured',
    title: 'AgenticAI host is not configured',
    message: `No AgenticAI host is set for this ${ACCOUNT_LABEL.singularLower}, and the server has no default host. Set the AgenticAI Host in the ${ACCOUNT_LABEL.singularLower}'s AI Agent settings, or contact your administrator.`,
    toast: `No AgenticAI host is configured for this ${ACCOUNT_LABEL.singularLower}. Set it in the ${ACCOUNT_LABEL.singularLower} settings or contact your administrator.`,
  },
};

/** The service error descriptor for an API error, or null when it is any other error. */
export const getAgenticAiServiceError = (err) => {
  const code = err?.response?.data?.code;
  return (code && AGENTIC_AI_SERVICE_ERRORS[code]) || null;
};

export const isAgenticAiServiceError = (err) => Boolean(getAgenticAiServiceError(err));
